import { pathJoin } from 'src/reducers/routing/utils'

// PRO-400: Map Layers & Zones became a routed-tab section so Municipalities
// (moved out of Customer Management settings) can sit alongside Zones and Map
// layers as a peer tab whose list-detail routes off its own path segment. The
// section's base URL redirects to the first tab (zones), preserving the old
// default landing. Municipalities' list-detail lives at
// `.../map-layers-zones/municipalities/:formSelectedId` (LayoutListView).
export const createMapLayersZonesRoutesMap = (prefix: string) => ({
  zones: pathJoin(prefix)('zones').chain,
  'map-layers': pathJoin(prefix)('map-layers').chain,
  municipalities: pathJoin(prefix)('municipalities').chain,
})
